// eslint-disable-next-line import/no-unresolved
import tippy from 'tippy.js';
import breakpoints from 'js/breakpoints';
import { getSvgSpritePath, parseHtmlToDom } from 'js/tools';

const RESIZE_TIMEOUT = 200;
const CONFIG = {
    selectors: {
        tooltip: '[data-tooltip]'
    },
    dataAttributes: {
        tooltipInitialized: 'data-tooltip-initialized'
    },
    base: {
        theme: 'viabovag',
        delay: 0,
        arrow: true,
        duration: 300,
        animation: 'shift-away',
        interactive: true,
        allowHTML: true,
        trigger: 'click focus'
    },
    mobile: {
        // offset: '280, 0',
        placement: 'top'
    },
    tabletPlus: {
        // offset: '-50, 5',
        placement: 'right'
    }
};

export default class ToolTips {
    constructor() {
        this.config = { ...CONFIG };
        this.init();
        this.bindListeners();
    }

    init() {
        const deviceSpecificConfig = this.deviceConfig();

        this.tooltipInstances = document.querySelectorAll(
            `${this.config.selectors.tooltip}:not([${this.config.dataAttributes.tooltipInitialized}])`
        );

        this.tooltipInstances.forEach(instance => {
            const contentSelector = instance.dataset.tooltip;
            if (contentSelector) {
                deviceSpecificConfig.content = document.querySelector(contentSelector);
            }
            if (instance.getAttribute('title')) {
                this.makeV1CompatibleToLatest(instance);
            }
            instance.setAttribute(this.config.dataAttributes.tooltipInitialized, true);
            tippy(instance, deviceSpecificConfig);
        });
    }

    bindListeners() {
        window.addEventListener('resize', () => {
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }

            this.resizeTimeout = setTimeout(() => {
                this.updatePlacement();
            }, RESIZE_TIMEOUT);
        });
    }

    makeV1CompatibleToLatest(instance) {
        const tippyContent = instance.getAttribute('title');
        instance.removeAttribute('title');
        instance.setAttribute('data-tippy-content', tippyContent);
    }

    static createCloseButton(popperInstance) {
        const closeButton = parseHtmlToDom(`
            <button class="tooltip__close-button">
                <svg viewBox="0 0 12 12" class="icon icon-close">
                    <use xlink:href="${getSvgSpritePath()}#close"></use>
                </svg>
            </button>
        `);

        closeButton.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();
            popperInstance.hide();
        });

        return closeButton;
    }

    deviceConfig() {
        const configName = breakpoints.onBreakpointOrGreater('tablet') ? 'tabletPlus' : 'mobile';
        return {
            ...this.config.base,
            ...this.config[configName],
            onShow: instance => {
                const tooltip = instance.popper.querySelector('.tippy-box');

                if (tooltip.querySelector('.tooltip__close-button') === null) {
                    const closeButton = ToolTips.createCloseButton(instance);

                    tooltip.appendChild(closeButton);
                }
            }
        };
    }

    hide() {
        this.tooltipInstances.forEach(tooltipInstance => {
            if (typeof tooltipInstance._tippy !== 'undefined') {
                tooltipInstance._tippy.hide();
            }
        });
    }

    updatePlacement() {
        this.tooltipInstances.forEach(tooltipInstance => {
            if (typeof tooltipInstance._tippy !== 'undefined') {
                tooltipInstance._tippy.setProps({
                    placement: this.deviceConfig().placement
                });
            }
        });
    }
}
